/*
 * Copyright © Manatee. 2026 All Rights Reserved.
 * Proprietary and confidential.
 */

import { type ReactNode } from "react";
import { cn } from "../lib/utils";

/** The detail-page card: a titled section. Renders in place, no entrance choreography. */
export function Section({
  title,
  children,
  className,
}: {
  title: string;
  children: ReactNode;
  className?: string;
}) {
  return (
    <section className={cn("border border-border bg-bg-elevated shadow-card rounded-3xl p-5 sm:p-6", className)}>
      <h2 className="font-display text-lg text-text-primary">{title}</h2>
      <div className="mt-3">{children}</div>
    </section>
  );
}

/** Label/value rows inside a Section. */
export function Facts({ facts }: { facts: [string, ReactNode][] }) {
  return (
    <dl className="grid gap-x-4 gap-y-2 text-sm sm:grid-cols-[auto_1fr]">
      {facts.map(([label, value]) => (
        <div key={label} className="contents">
          <dt className="text-text-tertiary">{label}</dt>
          <dd className="min-w-0 text-text-primary">{value}</dd>
        </div>
      ))}
    </dl>
  );
}
